import { Component } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

import List from './List';
import Icon from 'components/Icon';
import Select from 'components/Select';

import {
  BoxContainer,
  FilterContainer,
  HeaderContainer,
  Truncate,
  LocalIconMenuItem,
} from './styles';

import notify from 'components/Notify';
import { black } from 'utils/style/colors';
import { navigate } from '@reach/router';
import { parse } from 'query-string';
import TagSearchBox from '../TagSearchBox/TagSearchBox';
import LocalIcon from '../../ui/LocalIcon';
import Dropdown from '../Dropdown';
import Input from '../Input/Input';
import i18n, { languageDirection } from '../../i18n';
import Modal from '../Modal/Modal';
import Vira from './ItemsViewer/Vira';
import {
  IProviderItemViewWithData,
  ITags,
} from '../../store/providers/providerTypes';
import { IOption } from '../Select/Select';
import { ISearchTerm } from '../../containers/Profile/Panels/DocumentManager/DocumentManager';

export interface IFolder {
  type: string;
  value: number | string;
  fastAccess?: number;
}

export interface IListItems {
  [key: number | string]: any;
}

interface IProps {
  listItems: IListItems;
  folders?: { [key: number]: { state: string } };
  openFolders: Array<ISearchTerm>;
  onLoadItemsByDad: (id: number) => void;
  onOpenFolder: (index: number, value: any) => void;
  searching?: boolean;
  onDrop: (itemId: number, newOrder: number, newDadId: number) => void;
  columnsChanged?: (colNumber: number) => void;
  searchItems?: { [key: string]: number[] };
  items?: { [key: number]: IProviderItemViewWithData };
  roleId?: string;
  isAdmin: boolean;
  isOwnerOrSupport?: boolean;
  providerId: number;
  ShowDeletedItemHandler?: (
    showDeletedDocuments: boolean,
    idList: number[]
  ) => void;
  ShowDeletedTagsHandler?: () => void;
  showTags?: boolean;
  rootFolderId?: number;
  tags?: ITags['data'];
  type?: 'folder' | 'search' | 'tag';
}

interface ISearchValue {
  value: number;
  label: string;
}

interface IState {
  focusIndex: number;
  colNumber: number;
  searchValues: Array<ISearchValue>;
  searchText: string;
  currentSearchText: string;
  showDeletedDocuments: boolean;
  showViraModal: boolean;
  windowWidth: number;
}

class MultiList extends Component<IProps, IState> {
  protected openLists;
  constructor(props: IProps) {
    super(props);
    this.state = {
      focusIndex: 0,
      colNumber: this.getNumberOfColumns(),
      searchValues: [],
      searchText: '',
      currentSearchText: '',
      showDeletedDocuments: false,
      showViraModal: false,
      windowWidth: window.innerWidth,
    };
    this.openLists = {};
    if (props.openFolders[0]?.type === 'search') {
      const parsed = parse(props.openFolders[0].value?.toString() || '');
      this.setState({
        searchText: parsed.q as string,
        currentSearchText: parsed.q as string,
      });
      if (parsed.folder) {
        const folderId = Number(parsed.folder);
        setTimeout(() => {
          this.setState({
            searchValues: [
              {
                value: folderId,
                label: this.props.items![folderId]?.data?.name as string,
              },
            ],
          });
        }, 250);
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.props.columnsChanged &&
      this.props.columnsChanged(this.state.colNumber);
  }

  componentDidUpdate(prevProps: IProps) {
    if (
      this.props.openFolders[0]?.type === 'search' &&
      prevProps.openFolders[0]?.value !== this.props.openFolders[0]?.value
    ) {
      const parsed = parse(this.props.openFolders[0].value as string);
      const update: {
        searchText?: string;
        currentSearchText?: string;
        searchValues?: Array<ISearchValue>;
      } = {};
      update.searchText = parsed.q as string;
      update.currentSearchText = parsed.q as string;
      if (parsed.folder) {
        const folderId = Number(parsed.folder);
        update.searchValues = [
          {
            value: folderId,
            label: this.props.items![folderId]?.data?.name as string,
          },
        ];
      }
      this.setState({
        searchText: update.searchText,
        currentSearchText: update.currentSearchText,
        searchValues: update.searchValues as ISearchValue[],
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  handleSearchContent = () => {
    const itemToSearch = this.state.searchText;
    const { rootFolderId } = this.props;
    const rootFolder =
      this.props.items![(rootFolderId || this.props?.openFolders?.[0]?.value)!]
        .data;
    const providerId = rootFolder.providerId;
    const folderId = rootFolder.dadId ? rootFolder.id : null;
    const searchInFolderId = this.state.searchValues[0]?.value;
    let query = `/content/${providerId}/`;
    if (folderId) query = `${query}f/${folderId}/`;
    if (itemToSearch && itemToSearch.length > 0) {
      query = `${query}search?q=${itemToSearch}`;
      if (searchInFolderId) {
        query = `${query}&folder=${searchInFolderId}`;
      }
    }
    navigate(query);
  };

  onSearchValues = (item: any) => {
    const newValue = item.length > 0 ? [item.at(-1)] : [];
    if (
      newValue.length === this.state.searchValues.length &&
      (newValue.length === 0 ||
        newValue[0].value === this.state.searchValues[0].value) &&
      this.state.searchText.length > 0
    ) {
      this.handleSearchContent();
    } else
      this.setState((prevState) => {
        return {
          ...prevState,
          searchValues: newValue,
        };
      });
  };

  handleChangeName = (value: string) => {
    this.setState({ searchText: value });
  };

  getNumberOfColumns() {
    const width = window.innerWidth;
    return width <= 600 ? 1 : width <= 992 ? 2 : width <= 1200 ? 3 : 4;
  }

  updateDimensions = () => {
    const colNumber = this.getNumberOfColumns();
    this.setState({ colNumber, windowWidth: window.innerWidth });
    this.props.columnsChanged && this.props.columnsChanged(colNumber);
  };

  forceUpdateHandler = () => {
    this.forceUpdate();
  };

  onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const itemId = result.draggableId;
    const newIndex = result.destination.index;
    const newDadId = result.destination.droppableId;
    const oldDadId = result.source.droppableId;
    const oldIndex = result.source.index;
    const parentItem = Object.values(this.props.listItems).find(
      (item: any) => item.id === Number(newDadId)
    );

    const list = this.openLists[newDadId];

    if (!parentItem?.isEditable) {
      notify(
        i18n.t('destinationFolderIsNotEditable', { ns: 'documentManager' }),
        'error'
      );
      return;
    }

    let newOrder;
    // dropped in same list as before
    if (newDadId === oldDadId) {
      if (newIndex === 0) {
        //dropped in first of list
        const bottomItemOrder = list[newIndex].order;
        newOrder = bottomItemOrder - 1;
      } else if (newIndex + 1 === list.length) {
        //dropped in end of list
        const topItemOrder = list[newIndex].order;
        newOrder = topItemOrder + 1;
      } else if (newIndex > oldIndex) {
        // pull down a list item
        const topItemOrder = list[newIndex].order;
        const bottomItemOrder = list[newIndex + 1].order;
        newOrder = (topItemOrder + bottomItemOrder) / 2;
      } else {
        // pull up a list item
        const topItemOrder = list[newIndex - 1].order;
        const bottomItemOrder = list[newIndex].order;
        newOrder = (topItemOrder + bottomItemOrder) / 2;
      }
    }
    // dropped in other list
    else {
      if (newIndex === 0) {
        //dropped in first of list
        if (list.length === 0) {
          //dropped in empty list
          newOrder = 0;
        } else {
          const bottomItemOrder = list[newIndex].order;
          newOrder = bottomItemOrder - 1;
        }
      } else if (newIndex === list.length) {
        //dropped in end of list
        const topItemOrder = list[newIndex - 1].order;
        newOrder = topItemOrder + 1;
      } else {
        const topItemOrder = list[newIndex - 1].order;
        const bottomItemOrder = list[newIndex].order;
        newOrder = (topItemOrder + bottomItemOrder) / 2;
      }
    }
    this.props.onDrop(itemId, newOrder, newDadId);
  };

  render() {
    const {
      items,
      roleId,
      folders,
      listItems,
      searching,
      searchItems,
      openFolders,
      onOpenFolder,
      onLoadItemsByDad,
      ShowDeletedItemHandler,
      ShowDeletedTagsHandler,
      showTags,
      isOwnerOrSupport,
    } = this.props;
    const showPath = true; // openFolders.length > this.state.colNumber;

    const isMobileView = this.state.windowWidth <= 600;

    const getFileSearch = () => {
      const searchOptions: IOption[] = openFolders
        .map((item, ind) => {
          if (!ind || (item.value && !listItems[item?.value]?.dadId))
            return { label: '', value: '' };
          return {
            label: i18n.t('searchIn', {
              name: listItems[item.value!].name,
              ns: 'documentManager',
            }) as string,
            value: item.value as string,
          };
        })
        .filter((it) => !!it)
        .filter((item) => item.label !== '' && item.value !== '');
      return (
        <Select
          placeholder={i18n.t('search', { ns: 'documentManager' })}
          values={this.state.searchValues}
          options={searchOptions}
          multiChoice={true}
          onChangeValues={this.onSearchValues}
          onSearch={this.handleChangeName}
          containerStyle={{
            flexGrow: isMobileView || this.state.searchValues?.length ? 1 : 0,
            minWidth: i18n.language === 'en' && '15rem',
          }}
          initSearchText={this.state.searchText}
          dropDownIcon={'search'}
          dropDownIconClick={() => this.onSearchValues(this.state.searchValues)}
        />
      );
    };
    const search =
      this.props.type === 'tag' ? (
        <TagSearchBox
          tags={{ data: this.props.tags }}
          providerId={this.props.providerId}
        />
      ) : (
        getFileSearch()
      );
    if (this.state.showViraModal) {
      return (
        <Modal
          title={i18n.t('viraSettings', { ns: 'documentManager' })}
          onClose={() => this.setState({ showViraModal: false })}
          width="95%"
          isActive={this.state.showViraModal}
          key="ViraSettings"
        >
          <Vira providerId={this.props.providerId.toString()} />
        </Modal>
      );
    }

    const path = window.location.pathname; // "/content/172/f/972"
    const match = path.match(/\/f\/(\d+)/);

    const folderId = match ? match[1] : null;

    return (
      <BoxContainer>
        <HeaderContainer>
          <div
            style={{
              padding: '10px 20px',
              gap: '10px',
              flexDirection: isMobileView ? 'column' : 'row',
              alignItems: isMobileView ? 'flex-start' : 'center',
            }}
          >
            <Truncate
              style={{
                float: languageDirection() === 'rtl' ? 'right' : 'left',
                flexGrow: 1,
                marginInlineStart: isMobileView ? '2rem' : '0',
                width: isMobileView ? '100%' : 'auto',
              }}
            >
              {openFolders.map((item, index) => {
                if (item.type === 'search') {
                  return (
                    <>
                      <a
                        key={item.value + 'root'}
                        href="#!"
                        style={{ display: 'inline-flex' }}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('./');
                        }}
                      >
                        <Icon type="home" color={black} />
                        {this.props.rootFolderId ? (
                          this.props.items![this.props.rootFolderId]?.data.name
                        ) : (
                          <span />
                        )}
                      </a>
                      {folderId && (
                        <a
                          key={item.value}
                          href="#!"
                          style={{
                            display: 'inline-flex',
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            onOpenFolder(index, item.value);
                          }}
                        >
                          <Icon type="chevron-left" color={black} />
                          <Icon type="search" />
                          {
                            i18n.t('searchIn', {
                              name: `${listItems?.[folderId]?.name}`,
                              ns: 'documentManager',
                            }) as string
                          }
                        </a>
                      )}
                    </>
                  );
                }
                if (!listItems[item.value!]) return null;
                if (
                  (!listItems[item.value!].dadId && item.type !== 'tag') ||
                  item.value === 0
                ) {
                  return (
                    <a
                      key={item.value}
                      href="#!"
                      style={{ display: 'inline-flex' }}
                      onClick={(e) => {
                        e.preventDefault();
                        onOpenFolder(index, item.value);
                      }}
                    >
                      <Icon type="home" />
                    </a>
                  );
                }
                return (
                  <a
                    key={item.value}
                    href="#!"
                    style={{ display: 'inline-flex' }}
                    onClick={(e) => {
                      e.preventDefault();
                      onOpenFolder(index, item.value);
                    }}
                  >
                    {languageDirection() === 'rtl' ? (
                      <Icon type="chevron-left" color={black} />
                    ) : (
                      <Icon type="chevron-right" color={black} />
                    )}
                    {listItems[item.value!].name}
                  </a>
                );
              })}
            </Truncate>
            <FilterContainer>
              {this.props.isAdmin && (
                <Dropdown
                  marginToTarget={5}
                  placement="bottom-start"
                  width={220}
                  trigger="click"
                  target={
                    <span className="hide-on-mobile">
                      <LocalIcon
                        iconName={'setting.svg'}
                        color={black}
                        type="medium"
                      />
                    </span>
                  }
                >
                  <Dropdown.Menu>
                    <Dropdown.MenuItem>
                      <span>
                        <Input
                          name="showDeletedDocuments"
                          id="showDeletedDocuments"
                          type="checkbox"
                          checked={
                            ShowDeletedItemHandler
                              ? this.state.showDeletedDocuments
                              : showTags
                          }
                          onChange={(e) => {
                            if (ShowDeletedItemHandler) {
                              ShowDeletedItemHandler(
                                e.target.checked,
                                this.props.openFolders.map(
                                  (val) => val.value as number
                                )
                              );
                              this.setState((prevState) => {
                                return {
                                  ...prevState,
                                  showDeletedDocuments: e.target.checked,
                                };
                              });
                            } else if (ShowDeletedTagsHandler) {
                              ShowDeletedTagsHandler();
                            }
                          }}
                          label={
                            ShowDeletedItemHandler
                              ? (i18n.t('showDeletedItem', {
                                  ns: 'documentManager',
                                }) as string)
                              : (i18n.t('showDeletedTags', {
                                  ns: 'documentManager',
                                }) as string)
                          }
                        />
                      </span>
                    </Dropdown.MenuItem>
                    <Dropdown.MenuItem
                      onClick={() => {
                        navigate(`/content/${this.props.providerId}/tags`);
                      }}
                    >
                      <LocalIconMenuItem>
                        <LocalIcon iconName="tag.svg" color={black} />
                        {i18n.t('tags', { ns: 'documentManager' })}
                      </LocalIconMenuItem>
                    </Dropdown.MenuItem>
                    <Dropdown.MenuItem
                      onClick={() => {
                        navigate(`/content/${this.props.providerId}/settings`);
                      }}
                    >
                      <LocalIconMenuItem>
                        <LocalIcon iconName="setting.svg" color={black} />
                        {i18n.t('settings', { ns: 'documentManager' })}
                      </LocalIconMenuItem>
                    </Dropdown.MenuItem>
                    {isOwnerOrSupport && (
                      <Dropdown.MenuItem
                        onClick={() => {
                          this.setState({ showViraModal: true });
                        }}
                      >
                        <LocalIconMenuItem>
                          <LocalIcon iconName="ai-bot.svg" color={black} />
                          {i18n.t('viraSettings', { ns: 'documentManager' })}
                        </LocalIconMenuItem>
                      </Dropdown.MenuItem>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {search}
            </FilterContainer>
          </div>
        </HeaderContainer>

        <div
          className="row no-gutter"
          style={{
            height: isMobileView
              ? 'calc(100% - 120px)'
              : `calc(100% - ${showPath ? 55 : 10}px`,
          }}
        >
          {/* @ts-expect-error jsx error */}
          <DragDropContext
            onDragEnd={this.onDragEnd}
            style={{ height: '100%' }}
          >
            {openFolders.map((dadItem, index, array) => {
              if (array.length - index > this.state.colNumber) {
                return null;
              }
              let selected = null;
              if (array.length > index + 1) {
                selected = array[index + 1];
              }
              let searchMode: boolean;
              if (dadItem.type !== 'tag') {
                searchMode = !!searchItems![dadItem.value!];
              }
              const searchItemsIds = searchItems?.[dadItem.value!];
              const list = Object.values(listItems || {})
                .filter((item: any) => {
                  if (
                    item.status !== 'exists' &&
                    !this.state.showDeletedDocuments
                  )
                    return false;
                  if (item.hidden) return false;
                  if (dadItem.type === 'search') {
                    if (searchItemsIds) {
                      return searchItemsIds.includes(item.id);
                    }
                    return false;
                  } else if (dadItem.type === 'folder') {
                    const parentItem = items![dadItem.value!];
                    if (!parentItem) return false;
                    if (parentItem.data.type === 'searchTag') {
                      if (parentItem.data.virtualChildren) {
                        return !!Object.values(
                          parentItem?.data?.virtualChildren || {}
                        )?.find((child) => child === item.id);
                      }
                      return false;
                    } else if (
                      Object.values(parentItem.data.itemLinks || {}).find(
                        (link: any) => link.destinationItemId === item.id
                      )
                    ) {
                      return true;
                    }
                  }

                  return item.dadId === dadItem.value;
                })
                .filter((item: any) => {
                  if (dadItem.type === 'folder' && dadItem.fastAccess) {
                    const thisItem = items![item.id];
                    return (
                      thisItem.data.fastAccess.includes(`role$$${roleId}`) ||
                      thisItem.data.implicitFastAccess.includes(
                        `role$$${roleId}`
                      )
                    );
                  }
                  return true;
                })
                .sort((a: any, b: any) => {
                  if (searchMode) {
                    const aItemId = a['id'];
                    const bItemId = b['id'];
                    const foundItems = searchItems![dadItem.value!];
                    return foundItems.indexOf(aItemId) >
                      foundItems.indexOf(bItemId)
                      ? 1
                      : -1;
                  } else {
                    if (!a.order) {
                      return 1;
                    }
                    if (!b.order) {
                      return -1;
                    }
                    return a.order - b.order;
                  }
                });

              this.openLists[dadItem.value!] = list;
              return (
                <div
                  key={dadItem.value}
                  data-index={index}
                  className="col s12 m6 l4 xl3"
                  style={{
                    height: '100%',
                    float: languageDirection() === 'rtl' ? 'right' : 'left',
                  }}
                >
                  <List
                    listItems={list}
                    dadItem={
                      dadItem.type === 'folder' || dadItem.type === 'tag'
                        ? listItems[dadItem.value!]
                        : undefined
                    }
                    loading={
                      dadItem.type === 'folder'
                        ? folders![dadItem.value!] &&
                          folders![dadItem.value!].state !== 'loaded'
                        : false
                    }
                    searching={searching || false}
                    lastList={index === array.length - 1}
                    onLoadItemsByDad={onLoadItemsByDad}
                    listIndex={index}
                    selected={selected}
                    items={items}
                    providerId={this.props.providerId}
                  />
                </div>
              );
            })}
          </DragDropContext>
        </div>
      </BoxContainer>
    );
  }
}

export default MultiList;
